<footer>
  <div class="main-footer">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-start py-4">
          <div class="py-5 text-center text-md-start">
            <h4 class="fw-light mb-4">{{ 'footer.choose_language' | translate }}</h4>
            <div class="footer-lang-changer">
              <button type="button" (click)="langChange('de')" [class.active]="'de' === currentLang" title="Deutsch">
                Deutsch
              </button>
              <button type="button" (click)="langChange('en')" [class.active]="'en' === currentLang" title="English">
                English
              </button>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end py-4">
          <div class="py-5">
            <h4 class="fw-light text-uppercase text-center text-md-start px-md-4 mb-4">{{ 'footer.social_media' | translate }}</h4>
            <div class="d-flex align-content-center">
              <a class="footer-social-media-link facebook" href="https://www.facebook.com/bmw.welt" target="_blank" title="Facebook"><i class="fa-brands fa-facebook-f"></i></a>
              <a class="footer-social-media-link instagram" href="https://www.instagram.com/bmwwelt" target="_blank" title="Instagram"><i class="fa-brands fa-instagram"></i></a>
              <a class="footer-social-media-link twitter" href="https://twitter.com/bmw_welt" target="_blank" title="Twitter"><i class="fa-brands fa-twitter"></i></a>
              <a class="footer-social-media-link youtube" href="https://www.youtube.com/channel/UC57VXWs3FD1DauwBWZQmM7A" target="_blank" title="YouTube"><i class="fa-brands fa-youtube"></i></a>
            </div>
          </div>
        </div>
      </div>
      <div class="row border-top footer-border">
        <div class="col-12 py-4 py-md-5">
          <p class="footer-link">
            <a href="{{ '/footer/metanavigation/kontakt.html' | footerLink: currentLang }}" target="_blank" title="{{ 'footer.contact' | translate }}">
              {{ 'footer.contact' | translate }}
            </a>
          </p>
          <p class="footer-link">
            <a href="{{ '/footer/metanavigation/newsletter.html' | footerLink: currentLang }}" target="_blank" title="{{ 'footer.newsletter' | translate }}">
              {{ 'footer.newsletter' | translate }}
            </a>
          </p>
          <p class="footer-link">
            <a href="https://www.bmwgroup.jobs/de/{{ currentLang }}.html" target="_blank" title="{{ 'footer.career' | translate }}">
              {{ 'footer.career' | translate }}
            </a>
          </p>
          <p class="footer-link">
            <a href="{{ '/footer/metanavigation/museum-app.html' | footerLink: currentLang }}" target="_blank" title="{{ 'footer.museum_app' | translate }}">
              {{ 'footer.museum_app' | translate }}
            </a>
          </p>
          <p class="footer-link">
            <a href="{{ '/footer/metanavigation/bmw-websites.html' | footerLink: currentLang }}" target="_blank" title="{{ 'footer.more_bmw_websites' | translate }}">
              {{ 'footer.more_bmw_websites' | translate }}
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="second-footer">
    <div class="container">
      <div class="row py-md-4">
        <div class="col-12 col-md-7 order-md-2 text-center text-md-end pt-4 pb-3 p-md-0">
          <a class="footer-secondary-links" href="{{ (currentLang === 'de' ? '/footer/metanavigation/barrierefreiheitserklaerung.html' : '/footer/metanavigation/accessibility.html' ) | footerLink: currentLang }}" target="_blank" title="{{ 'footer.legal_links.accessibility' | translate }}">
            {{ 'footer.legal_links.accessibility' | translate }}
          </a>
          <a class="footer-secondary-links" href="{{ '/footer/metanavigation/legal-notice-pool/impressum.html' | footerLink: currentLang }}" target="_blank" title="{{ 'footer.legal_links.imprint' | translate }}">
            {{ 'footer.legal_links.imprint' | translate }}
          </a>
          <a class="footer-secondary-links" href="{{ '/footer/metanavigation/data-privacy.html' | footerLink: currentLang }}" target="_blank" title="{{ 'footer.legal_links.privacy' | translate }}">
            {{ 'footer.legal_links.privacy' | translate }}
          </a>
          <a class="footer-secondary-links" href="{{ '/footer/metanavigation/legal-disclaimer-pool/legal-disclaimer.html' | footerLink: currentLang }}" target="_blank" title="{{ 'footer.legal_links.legal_notice' | translate }}">
            {{ 'footer.legal_links.legal_notice' | translate }}
          </a>
          <a class="footer-secondary-links" routerLink="/cookies" title="{{ 'footer.legal_links.cookies' | translate }}">
            {{ 'footer.legal_links.cookies' | translate }}
          </a>
        </div>
        <div class="col-12 col-md-5 order-md-1 text-center text-md-start pb-4 pt-3 p-md-0">
          <p class="small fw-light m-0">© BMW AG {{ currentYear }} powered by <a target="_blank" rel="noopener" class="text-reset text-decoration-none" href="https://hello-one.de">hello-one.de</a></p>
        </div>
      </div>
    </div>
  </div>
</footer>
